/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();
import 'slick-carousel';

'use strict';
const productPopup = {
	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {
		$(document).on('click', '.js-view-gallery-property', function() {
			$('.js-slider-popup-property').addClass('active');
			$('body').addClass('prevent-scroll');
		});
		$(document).on('click', '.js-close-gallery-property', function() {
			$('.js-slider-popup-property').removeClass('active');
			$('body').removeClass('prevent-scroll');
			setTimeout(() => {
				$('.js-popup-slider').slick('destroy');
				$('.js-popup-slider-nav').slick('destroy');
			}, 400);
		});
	},
};

export default productPopup;
